import {ValueObject} from '@s-ui/domain'

import {AdEntity} from '../Entities/AdEntity.js'

export class AdsListValueObject extends ValueObject {
  #ads

  constructor({ads}) {
    super()
    this.#ads = ads
  }

  static MAX_PAID_ADS = 5

  static mergePaidAds({ads, paidAds}) {
    return paidAds.length ? [...paidAds.slice(0, this.MAX_PAID_ADS).map(ad => ({...ad, isTop: true})), ...ads] : ads
  }

  static createWithPaidAds({ads, paidAds}) {
    const mergedAds = AdsListValueObject.mergePaidAds({ads, paidAds})
    return new AdsListValueObject({ads: mergedAds.map(ad => AdEntity.createFromListingApi({ad}))})
  }

  get ads() {
    return this.#ads.map(ad => ad.value)
  }

  get value() {
    return this.ads
  }
}
